import { Empresas } from '@infotrack/presentacion-modulosbase';
import { seguridadToken } from 'Infotrack@Modelos/conexiones';
import React from 'react';

const Empresa: React.FunctionComponent = () => {
    return <Empresas seguridad={seguridadToken} />;
};

export default Empresa;
